import { render, staticRenderFns } from "./EmailClassificationEditView.vue?vue&type=template&id=b2a84c2e"
import script from "./EmailClassificationEditView.vue?vue&type=script&lang=js"
export * from "./EmailClassificationEditView.vue?vue&type=script&lang=js"
import style0 from "./EmailClassificationEditView.vue?vue&type=style&index=0&id=b2a84c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports